import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/subscription-features";
const v2 = "admin/subscription";

export const SubscriptionFeatureUpdate = async (values) => {
  return await axiosInstance(options).post(`${path}/update`, values);
};

export const SubscriptionFeatureList = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const SubscriptionFeatureAdd = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
};

export const SubscriptionFeatureUpdateOne = async (values) => {
  return await axiosInstance(options).post(`${path}/update-one`, values);
};

export const SubscriptionActionKeys = async () => {
  return await axiosInstance(options).get(`${v2}/action-keys`);
};

export const SubscriptionUserEntitlements = async (id) => {
  return await axiosInstance(options).get(`${v2}/user?o_id=${id}`);
};
